import React from 'react'
import { Container } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import SEO from '../../components/SEO'
import './FAQ.css'

const faqItems = [
  {
    question: 'Do I need an appointment?',
    answer:
      'Appointments are recommended to guarantee your preferred time. You can book online or call us directly.',
  },
  {
    question: 'What hair services do you offer?',
    answer:
      'We offer braiding styles including box braids, cornrows, Senegalese twists, Havana twists, micro braids, and more protective styles.',
  },
  {
    question: 'How should I prepare for my braiding appointment?',
    answer:
      'Please arrive with clean, detangled hair. If you have any sensitivity or scalp concerns, let your stylist know before your service.',
  },
  {
    question: 'How long do braids usually last?',
    answer:
      'Depending on style and maintenance, most braids can last several weeks. We recommend regular scalp care and bonnet/satin protection at night.',
  },
  {
    question: 'Where are you located?',
    answer:
      'We are located at 7701 Sudley Road, Manassas, VA 20109. Visit our Location page for map and directions.',
  },
  {
    question: 'How can I book?',
    answer:
      'You can book directly through our booking page or call us at 703-936-3026.',
  },
]

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
}

export default function FAQ() {
  return (
    <div className="faq-page">
      <SEO
        title="FAQ"
        description="Frequently asked questions about appointments, services, preparation, and location at Sarah Adom Braiding Salon."
        path="/faq"
      />
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>
      <Container className="faq-container">
        <header className="faq-header">
          <span className="faq-label">Help</span>
          <h1>Frequently Asked Questions</h1>
          <p>Quick answers about booking, styles, and visiting the salon.</p>
        </header>

        <section className="faq-list" aria-label="FAQ list">
          {faqItems.map((item) => (
            <article key={item.question} className="faq-item">
              <h2>{item.question}</h2>
              <p>{item.answer}</p>
            </article>
          ))}
        </section>
      </Container>
    </div>
  )
}
